import React from 'react';

const PROMO_TYPES = [
  { value: 'multiplier', label: 'Множитель ×N', valueLabel: 'N (множитель)', placeholder: '2', step: '0.1' },
  { value: 'extra_percent', label: '+N% к кэшбэку', valueLabel: 'N (процентов)', placeholder: '10', step: '1' },
  { value: 'birthday', label: 'Повышенный кэшбэк в ДР', valueLabel: '+N% в день рождения', placeholder: '15', step: '1' },
];

const emptyPromo = () => ({
  name: 'Новая акция',
  enabled: true,
  promoType: 'multiplier',
  promoValue: 2,
  startDate: new Date().toISOString().slice(0, 10),
  endDate: new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10),
  daysOfWeek: [],
  templateIds: [],
  birthdayDaysBefore: 0,
});

const DAYS = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

const PromosTab = ({ promos, templates, updatePromos }) => {
  const updatePromo = (index, field, value) => {
    const updated = [...promos];
    updated[index] = { ...updated[index], [field]: value };
    updatePromos(updated);
  };

  const toggleDay = (index, day) => {
    const days = [...(promos[index].daysOfWeek || [])];
    const pos = days.indexOf(day);
    if (pos >= 0) days.splice(pos, 1);
    else days.push(day);
    updatePromo(index, 'daysOfWeek', days.sort());
  };

  const getTypeMeta = (type) => PROMO_TYPES.find((t) => t.value === type) || PROMO_TYPES[0];

  const addPromo = () => updatePromos([...promos, emptyPromo()]);
  const removePromo = (index) => updatePromos(promos.filter((_, i) => i !== index));

  return (
    <div className="admin-section">
      <div className="admin-row-between">
        <h2>Промо-акции</h2>
        <button type="button" className="admin-add-btn" onClick={addPromo}>+ Акция</button>
      </div>

      {!promos.length && <p className="admin-hint">Создайте акцию: ×2 кэшбэк в выходные, +10% в праздники или бонус в день рождения клиента.</p>}

      <div className="admin-cards-row">
      {promos.map((promo, i) => {
        const meta = getTypeMeta(promo.promoType);
        const isBirthday = promo.promoType === 'birthday';

        return (
          <div key={promo._id || i} className="admin-card-group">
            <div className="admin-promo-card-header">
              <label className="admin-field admin-checkbox admin-promo-title">
                <input type="checkbox" checked={!!promo.enabled} onChange={(e) => updatePromo(i, 'enabled', e.target.checked)} />
                <input type="text" className="admin-inline-input" value={promo.name} onChange={(e) => updatePromo(i, 'name', e.target.value)} />
              </label>
              <button type="button" className="admin-link-btn" onClick={() => removePromo(i)} title="Удалить">✕</button>
            </div>

            <div className="admin-grid-2">
              <label className="admin-field">
                <span>Тип акции</span>
                <select value={promo.promoType} onChange={(e) => updatePromo(i, 'promoType', e.target.value)}>
                  {PROMO_TYPES.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </label>
              <label className="admin-field">
                <span>{meta.valueLabel}</span>
                <input
                  type="number"
                  min="0"
                  step={meta.step}
                  placeholder={meta.placeholder}
                  value={promo.promoValue}
                  onChange={(e) => updatePromo(i, 'promoValue', Number(e.target.value))}
                />
              </label>
              <label className="admin-field">
                <span>Дата начала</span>
                <input type="date" value={(promo.startDate || '').slice(0, 10)} onChange={(e) => updatePromo(i, 'startDate', e.target.value)} />
              </label>
              <label className="admin-field">
                <span>Дата окончания</span>
                <input type="date" value={(promo.endDate || '').slice(0, 10)} onChange={(e) => updatePromo(i, 'endDate', e.target.value)} />
              </label>
            </div>

            {isBirthday ? (
              <label className="admin-field">
                <span>Начислить за N дней до дня рождения</span>
                <input
                  type="number"
                  min="0"
                  value={promo.birthdayDaysBefore ?? 0}
                  onChange={(e) => updatePromo(i, 'birthdayDaysBefore', Number(e.target.value))}
                />
              </label>
            ) : (
              <div className="admin-field">
                <span>Дни недели <em className="admin-hint-inline">(не выбрано = каждый день)</em></span>
                <div className="admin-day-chips">
                  {DAYS.map((label, day) => (
                    <button
                      key={day}
                      type="button"
                      className={`admin-day-chip ${(promo.daysOfWeek || []).includes(day) ? 'active' : ''}`}
                      onClick={() => toggleDay(i, day)}
                    >{label}</button>
                  ))}
                </div>
              </div>
            )}

            {templates.length > 1 && (
              <div className="admin-field">
                <span>Уровни <em className="admin-hint-inline">(не выбрано = все)</em></span>
                <div className="admin-day-chips">
                  {templates.map((t) => (
                    <button
                      key={t._id}
                      type="button"
                      className={`admin-day-chip ${(promo.templateIds || []).includes(t._id) ? 'active' : ''}`}
                      onClick={() => {
                        const ids = [...(promo.templateIds || [])];
                        const pos = ids.indexOf(t._id);
                        if (pos >= 0) ids.splice(pos, 1);
                        else ids.push(t._id);
                        updatePromo(i, 'templateIds', ids);
                      }}
                    >{t.name}</button>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
      </div>
    </div>
  );
};

export default PromosTab;
